/**
 * Created by razial on 10.11.2022
 */

cleverapps.overrideStyles(cleverapps.styles.Decorators, {
    "decor_title_right": {
        lovesTitle: "bg_window",
        type: Decors.TYPE_IMAGE,
        image: bundles.windows.frames.window_title_decor,
        scale: {
            x: -1,
            y: 1
        },
        zOrder: -1,
        x: { align: "right", dx: 105 },
        y: { align: "top", dy: 25 }
    },

    "decor_title_left": {
        lovesTitle: "bg_window",
        type: Decors.TYPE_IMAGE,
        image: bundles.windows.frames.window_title_decor,
        scale: {
            x: 1,
            y: 1
        },
        zOrder: -1,
        x: { align: "left", dx: -105 },
        y: { align: "top", dy: 25 }
    },

    "window_notch_top": {
        image: bundles.windows.frames.window_notch_top,
        type: Decors.TYPE_REPEATABLE,
        direction: cleverapps.UI.HORIZONTAL,
        step: 250,
        zOrder: 0,
        x: { align: "left" },
        y: { align: "top", dy: -12 },
        lovesBackgroundAndForeground: true
    },

    "window_notch_bottom": {
        image: bundles.windows.frames.window_notch_bottom,
        type: Decors.TYPE_REPEATABLE,
        direction: cleverapps.UI.HORIZONTAL,
        step: 250,
        zOrder: 0,
        x: { align: "left" },
        y: { align: "bottom", dy: 21 },
        lovesBackgroundAndForeground: true
    },

    "window_notch_bottom_background": {
        image: bundles.windows.frames.window_notch_bottom,
        type: Decors.TYPE_REPEATABLE,
        direction: cleverapps.UI.HORIZONTAL,
        step: 250,
        zOrder: 0,
        x: { align: "left" },
        y: { align: "bottom", dy: 21 },
        lovesBackground: true
    },

    "window_notch_left": {
        image: bundles.windows.frames.window_notch_left,
        type: Decors.TYPE_REPEATABLE,
        direction: cleverapps.UI.VERTICAL,
        step: 250,
        zOrder: 0,
        x: { align: "left", dx: 15 },
        y: { align: "bottom" },
        lovesBackgroundAndForeground: true
    },

    "window_notch_right": {
        image: bundles.windows.frames.window_notch_right,
        type: Decors.TYPE_REPEATABLE,
        direction: cleverapps.UI.VERTICAL,
        step: 250,
        zOrder: 0,
        x: { align: "right", dx: -14 },
        y: { align: "bottom" },
        lovesBackgroundAndForeground: true
    },

    "window_liana_top_left": {
        image: bundles.windows.frames.window_top_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "left", dx: -23 },
        y: { align: "top", dy: 46 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "window_liana_top_right": {
        image: bundles.windows.frames.window_top_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "right", dx: 24 },
        y: { align: "top", dy: 46 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: -1,
            y: 1
        }
    },

    "window_liana_left": {
        image: bundles.windows.frames.window_side_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "left", dx: -7 },
        y: { align: "bottom", dy: 186 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "window_liana_right": {
        image: bundles.windows.frames.window_side_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "right", dx: 7 },
        y: { align: "bottom", dy: 186 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: -1,
            y: 1
        }
    },

    "window_liana_bottom_left": {
        image: bundles.windows.frames.window_bottom_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "left", dx: -16 },
        y: { align: "bottom", dy: 0 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "window_liana_bottom_right": {
        image: bundles.windows.frames.window_bottom_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 1,
        x: { align: "right", dx: 31 },
        y: { align: "bottom", dy: 0 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: -1,
            y: 1
        }
    },

    "window_liana_left_front": {
        image: bundles.windows.frames.window_side_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 2,
        scale: [{ x: 0.8, y: 0.8 }, { x: 1, y: 1 }, { x: 1, y: 1 }],
        position: [
            { x: { align: "left", dx: -6 }, y: { align: "bottom", dy: 149 } },
            { x: { align: "left", dx: -7 }, y: { align: "bottom", dy: 186 } },
            { x: { align: "left", dx: -7 }, y: { align: "bottom", dy: 186 } }
        ]
    },

    "window_liana_right_front": {
        image: bundles.windows.frames.window_side_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 2,
        scale: [{ x: -0.8, y: 0.8 }, { x: -1, y: 1 }, { x: -1, y: 1 }],
        position: [
            { x: { align: "right", dx: 6 }, y: { align: "bottom", dy: 149 } },
            { x: { align: "right", dx: 7 }, y: { align: "bottom", dy: 186 } },
            { x: { align: "right", dx: 7 }, y: { align: "bottom", dy: 186 } }
        ]
    },

    "window_liana_bottom_left_front": {
        image: bundles.windows.frames.window_bottom_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 2,
        scale: [{ x: 0.8, y: 0.8 }, { x: 1, y: 1 }, { x: 1, y: 1 }],
        position: [
            { x: { align: "left", dx: -13 }, y: { align: "bottom", dy: 0 } },
            { x: { align: "left", dx: -16 }, y: { align: "bottom", dy: 0 } },
            { x: { align: "left", dx: -16 }, y: { align: "bottom", dy: 0 } }
        ]
    },

    "window_liana_bottom_right_front": {
        image: bundles.windows.frames.window_bottom_liana,
        type: Decors.TYPE_IMAGE,
        zOrder: 2,
        scale: [{ x: -0.8, y: 0.8 }, { x: -1, y: 1 }, { x: -1, y: 1 }],
        position: [
            { x: { align: "right", dx: 25 }, y: { align: "bottom", dy: 0 } },
            { x: { align: "right", dx: 31 }, y: { align: "bottom", dy: 0 } },
            { x: { align: "right", dx: 31 }, y: { align: "bottom", dy: 0 } }
        ]
    },

    "shop_marquise_coins": {
        image: bundles.tile_shop.frames.marquise_png,
        x: { align: "center" },
        y: { align: "top", dy: -15 }
    },

    "shop_marquise_prem": {
        image: bundles.tile_shop.frames.prem_marquise_png,
        x: { align: "center" },
        y: { align: "top", dy: -15 }
    },

    "shop_marquise_lives": {
        image: bundles.tile_shop.frames.marquise_png,
        x: { align: "center" },
        y: { align: "top", dy: -15 }
    },

    "xmas_window_right_bottom": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "down_right",
        x: { align: "right", dx: 15 },
        zOrder: 1,
        y: { align: "bottom", dy: -16 },
        lovesBackgroundAndForeground: true
    },

    "xmas_window_left_top": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window,
        animation: "up_left",
        x: { align: "left", dx: -23 },
        y: { align: "top", dy: 18 },
        zOrder: 1,
        lovesBackgroundAndForeground: true
    },

    "xmas_window_snowfall": {
        type: Decors.TYPE_ANIMATION,
        json: bundles.windows.jsons.xmas_window_snowfall,
        animation: "animation",
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        zOrder: -1,
        lovesWindow: true
    },

    "halloween_window_candle_right": {
        image: bundles.windows.frames.spiderweb_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: -35 },
        y: { align: "top", dy: -37 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_candle_left": {
        image: bundles.windows.frames.candle_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 70 },
        y: { align: "top", dy: 64 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_left": {
        image: bundles.windows.frames.lian_down_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: -15 },
        y: { align: "center", dy: 25 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_top": {
        image: bundles.windows.frames.lian_left_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "center", dx: 20 },
        y: { align: "top", dy: 26 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_right": {
        image: bundles.windows.frames.lian_down_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: 14 },
        y: { align: "center", dy: 33 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_lian_bottom": {
        image: bundles.windows.frames.lian_right_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 460 },
        y: { align: "top", dy: 62 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_decor_bg_right": {
        image: bundles.windows.frames.decor_bg,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: 63 },
        y: { align: "bottom", dy: 45 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_pumpkin": {
        image: bundles.windows.frames.pumpkin_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "right", dx: -158 },
        y: { align: "top", dy: 48 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    },

    "halloween_window_spider": {
        image: bundles.windows.frames.spider_decor,
        type: Decors.TYPE_IMAGE,
        x: { align: "left", dx: 37 },
        y: { align: "bottom", dy: 41 },
        lovesBackgroundAndForeground: true,
        scale: {
            x: 1,
            y: 1
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.SceneDecors, {
    xmas_menubar: {
        image: bundles.menubar.frames.xmas_menubar,
        x: { align: "left", dx: 17 },
        y: { align: "top", dy: 28 }
    }
});
